module.exports = __webpack_public_path__ + "static/website_setup-fd7d1fd1cdd9bffb0116087f12be8a61.svg";